(function(angular) {
	'use strict';

	function config(spAIAnalyticServiceProvider) {
		spAIAnalyticServiceProvider.getLocals = ['Config', 'User', function (config, user) {
			var userLoginData = user.getUserLoginData();
			return {
				userId: (userLoginData) ? userLoginData.uid : null,
				username: (userLoginData) ? userLoginData.email : null,
				languageId: (config.retailer)? config.retailer.languageId : config.retailerLanguageId
			};

		}];
	}

	function run($window, $q, $rootScope, Config, TrackingTransparency, spAIAnalyticService, AdobeAnalytics) {
		$q.all({
			config: Config.waitForInit(),
			tracking: TrackingTransparency.waitForPermission()
		}).then(function(results) {
			if (TrackingTransparency.isTrackingAllowed) {
				_addExposeboxAnalytics();
				_addAdobeAnalytics();
			}

			return;
		});

		function _addExposeboxAnalytics() {
			//ToDo: should have a cookie to check upon
			spAIAnalyticService.init();
		}

		function _addAdobeAnalytics() {
			//ToDo: should have a cookie to check upon
			AdobeAnalytics.init();
		}
	}

	angular.module('mobilezuz')
		.config(['spAIAnalyticServiceProvider', config])
		.run(['$window', '$q', '$rootScope', 'Config', 'TrackingTransparency', 'spAIAnalyticService', 'AdobeAnalytics', run]);
})(angular);
